<template>
  <tr @keyup.enter="filterChanged">
    <th/>
    <th class="input-wrapper cursor-pointer">
      <b-form-select
          :options="getFilterOptions('State')"
          text-field="label"
          value-field="value"
          @change="changeFilterValue($event, 'State')"
          v-model="filterValues['State']"
          placeholder="ANY"
          inputId="State"
          clearable/>
    </th>
    <th>
      <b-input-group>
        <b-form-input
            v-model="filterValues['Name']"
            placeholder="Name"
        ></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" :value="filter['Name']"
                 content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
        </b-input-group-append>
      </b-input-group>
    </th>

    <th class="input-wrapper cursor-pointer">
      <b-form-select
          :options="getFilterOptions('Entity')"
          text-field="label"
          value-field="value"
          @change="changeFilterValue($event, 'Entity')"
          v-model="filterValues['Entity']"
          placeholder="ANY"
          inputId="Entity"
          clearable/>
    </th>
    <th>
      <b-input-group>
        <b-form-input
            v-model="filterValues['Server']"
            placeholder="Server"
        ></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" :value="filter['Server']"
                 content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th>
      <b-input-group>
        <b-form-input
            v-model="filterValues['Ip']"
            placeholder="IP"
        ></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" :value="filter['Ip']"
                 content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th>
      <b-input-group>
        <b-form-input
            v-model="filterValues['Mac']"
            placeholder="MAC"
        ></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" :value="filter['Mac']"
                 content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th>
      <b-input-group>
        <b-form-input
            v-model="filterValues['Ram']"
            placeholder="RAM"
        ></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" :value="filter['Ram']"
                 content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th>
      <b-input-group>
        <b-form-input
            v-model="filterValues['Cpu']"
            placeholder="CPU"
        ></b-form-input>
        <b-input-group-append is-text>
          <input type="checkbox" v-model="filterExact" :value="filter['Cpu']"
                 content="Exact phrase" v-tippy="{arrow : true}" aria-label="Exact phrase">
        </b-input-group-append>
      </b-input-group>
    </th>
    <th>
            <span class="cel-buttons">
              <span class="icon-search" @click="filterChanged()" title="Apply filters"><i
                  class="fa fa-solid fa-search"></i></span>
               <span class="icon-clear" @click="clearFilter()" title="Clear filters">
                <font-awesome-icon icon="recycle" class="icon alt"/>
               </span>
            </span>
    </th>

  </tr>
</template>
<script>
import {EventBus} from "@/eventBus";

function debounce(that, fn, delay) {
  let timeoutID = undefined;
  return () => {
    clearTimeout(timeoutID);
    const args = arguments;
    timeoutID = setTimeout(() => {
      fn.apply(that, args);
    }, delay);
  };
}

import _ from "lodash"

export default {
  name: "VmFilters",
  emits: ['deleteItems', 'onChanged', 'changeTitle'],
  props: {
    filterExact: {
      type: Array,
      default: []
    },
    itemsSelectedCount: {
      type: Number,
      default: 0
    },
    title: String,
    result: Array,
    filter: {
      type: Array,
      default: function () {
        return {
          name: 'Name',
          value: '',
          w: 100
        }
      }
    },
    columns: {
      type: Array,
      default: () => {
        return [
          {
            name: '',
            value: '',
          }
        ]
      }
    },
    filterValues: {
      type: Object,
      default: function () {
        return {
          Name: '',
        }
      }
    }
  },
  data() {
    return {
      filters: [],
      queryFilter: [],
      filterWithColumns: [],
      newFilters: [],
    };
  },
  methods: {
    getFilterOptions(name) {
      const options = this.filterComputed.find(filter => filter.name === name)?.options
      if (name === 'State') {
        _.forEach(options, (option) => {
          if (option.value === 'OK') {
            option.label = "🟢OK"
          } else if (option.value === 'poweredOn') {
            option.label = "🟢ON"
          } else if (option.value === 'NO PING') {
            option.label = "🔴NO PING"
          } else if (option.value === 'poweredOff') {
            option.label = "🔴OFF"
          } else if (option.value === 'UNKNOWN') {
            option.label = "🤷‍UNKNOWN"
          } else if (option.value === 'DESTROYED') {
            option.label = "🚫DESTROYED"
          } else if (option.value === 'CREATED') {
            option.label = "🚀CREATED"
          } else if (option.value === 'CHANGED') {
            option.label = "⚠️CHANGED"
          } else if (option.value === 'MOVE_PENDING') {
            option.label = "🔜MOVE_PENDING"
          } else if (option.value === 'SUSPENDED') {
            option.label = "⏸️SUSPENDED"
          } else if (option.value === 'DELETED') {
            option.label = "🗑️DELETED"
          } else if (option.value === null) {
            option.label = "0️⃣NULL"
          }
        })
      } else if (name === 'Entity') {
        _.forEach(options, (option) => {
          if (option.label.toLowerCase() === 'managed') {
            option.label = "🛂Managed"
          } else if (option.label.toLowerCase() === 'diskless') {
            option.label = "⚡️Diskless"
          } else if (option.label.toLowerCase() === 'default') {
            option.label = " 🟨Default"
          }
        })
      }
      return options;
    },
    changeFilterValue(event, filter) {
      this.filterValues[filter] = event === null ? "" : event
      this.filterSend()
    },
    actionDelete() {
      this.$emit('deleteItems')
    },

    filterChanged() {
      this.debounced();
    },
    getUnnamedFilter(data) {
      let condition;
      let field;
      let value;
      if (Object.prototype.hasOwnProperty.call(data, 'Data') &&
          Object.prototype.hasOwnProperty.call(data, 'Condition')) {
        condition = data['Condition'];
        field = Object.keys(data['Data'])[0];
        value = data['Data'][field];
      }
      let fieldExist = false;
      for (let filterIndex in this.filter) {
        if (Object.prototype.hasOwnProperty.call(this.filter[filterIndex], 'name')) {
          if (field === this.filter[filterIndex].name) {
            fieldExist = true;
          }
        }
      }
      if (!fieldExist) {
        return ' ' + field + ' ' + condition + ' ' + value;
      }
      return '';
    },
    buttonFilter(filterConfig) {
      if (Object.keys(filterConfig || {}).length === 0) {
        return
      }
      if (!this.buttonCheck(filterConfig)) {
        this.pushFilters(filterConfig);
      } else {
        this.popFilters(filterConfig);
      }
      this.filterSend();
    },
    buttonCheck(filterConfig) {
      let keyCount = Object.keys(filterConfig || {}).length
      if (keyCount === 0) {
        return true;
      }
      let keyAlignmentCount = 0;
      for (let filterIdx in filterConfig) {
        let data = {};
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          return true;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        data[field] = value;

        for (let filterUsedIdx in this.filters) {
          let fieldUsed;
          let valueUsed;
          if (!this.filters[filterUsedIdx]) continue;
          if (this.filters[filterUsedIdx] == undefined) {
            console.log("WTF");
          }
          for (let fieldName in this.filters[filterUsedIdx].Data) {
            fieldUsed = fieldName;
            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
          }
          if (this.filters[filterUsedIdx].Condition === filterConfig[filterIdx].Condition &&
              fieldUsed == field && value == valueUsed) {
            keyAlignmentCount++;
          }
        }
      }
      if (keyCount === keyAlignmentCount) {
        return true;
      }
      return false;
    },
    pushFilters(filterConfig) {
      for (let filterIdx in filterConfig) {
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          continue;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        if (value) {
          this.filterValues[field] = value;
        }
      }
    },
    popFilters(filterConfig) {
      let filterCopy = [];
      for (let filterIdx in filterConfig) {
        let data = {};
        if (!filterConfig[filterIdx].Data || !filterConfig[filterIdx].Condition) {
          return true;
        }
        let field;
        let value;
        for (let fieldName in filterConfig[filterIdx].Data) {
          field = fieldName;
          value = filterConfig[filterIdx].Data[fieldName];
        }
        if (Object.keys(this.filterValues).includes(field)) {
          this.filterValues[field] = '';
        }
        data[field] = value;
        let filterExist = false;
        let lastFilterItem = {};
        for (let filterUsedIdx in this.filters) {
          let fieldUsed;
          let valueUsed;
          if (!this.filters[filterUsedIdx]) continue;
          if (this.filters[filterUsedIdx] === undefined) {
            console.log("WTF");
          }
          for (let fieldName in this.filters[filterUsedIdx].Data) {
            fieldUsed = fieldName;
            valueUsed = this.filters[filterUsedIdx].Data[fieldName];
          }
          if (this.filters[filterUsedIdx].Condition !== filterConfig[filterIdx].Condition &&
              fieldUsed != field && value != valueUsed) {
            filterExist = true;
            lastFilterItem = this.filters[filterUsedIdx];
          }
        }
        if (filterExist) {
          filterCopy.push(lastFilterItem);
          this.filterValues[field] = value;
        }
      }
      this.filters = filterCopy;
    },
    onRouteChange() {
      this.queryFilter = [];
      this.filters = [];
      this.filterQuery();
      this.$emit('onInit', this.filters);
    },
    filterQuery() {
      if (!this.$route.query.filter) {
        return;
      }
      this.queryFilter = JSON.parse(this.$route.query.filter);
      if (this.queryFilter.length == 0) {
        return;
      }
      if (this.queryFilter) {
        if (Object.keys(this.queryFilter || {}).length === 0) {
          for (let FieldName in this.filterValues) {
            this.filterValues[FieldName] = '';
          }
        }
        for (let filterIdx in this.queryFilter) {
          let data = {};
          if (!this.queryFilter[filterIdx].Data || !this.queryFilter[filterIdx].Condition) {
            continue;
          }
          let condition = this.queryFilter[filterIdx].Condition;
          let field;
          let value;
          for (let fieldName in this.queryFilter[filterIdx].Data) {
            field = fieldName;
            value = this.queryFilter[filterIdx].Data[fieldName];
          }
          if (value !== null && value !== undefined) {
            this.filterValues[field] = value;
          }
          data[field] = value;
          if (condition === '=') {
            this.filterExact.push(field)
          }
          this.filters.push({
            Condition: condition,
            Data: data,
          });
        }
      }
    },
    clearFilter() {
      for (let FieldName in this.filterValues) {
        this.filterValues[FieldName] = '';
      }
      this.filters = [];
      this.queryFilter = [];
      EventBus.$emit('UpdateTitle', this.newFilters);
      this.filterChanged();
    },
    filterSend() {
      let currentQuery = this.$route.query;
      this.newFilters = [];
      for (let FieldName in this.filterValues) {
        if (FieldName === "State" && this.filterValues[FieldName] === "CREATED") {
          this.newFilters.push({
            Condition: "ilike",
            Data: {
              State: "CREATED"
            }
          });
        } else if (FieldName === "State" && this.filterValues[FieldName] === "CHANGED") {
          this.newFilters.push({
            Condition: "ilike",
            Data: {
              State: "️CHANGED"
            }
          });
        } else if (this.filterValues[FieldName] !== '') {
          let data = {};
          data[FieldName] = this.filterValues[FieldName];
          if (this.filterExact.includes(FieldName)) {
            this.newFilters.push({
              Condition: "=",
              Data: data,
            });
          } else {
            this.newFilters.push({
              Condition: "ilike",
              Data: data,
            });
          }
        }
      }
      if (JSON.stringify(currentQuery) !== JSON.stringify({filter: JSON.stringify(this.newFilters)})) {
        this.$router.push({query: {filter: JSON.stringify(this.newFilters)}});
        this.$emit('onChanged', this.newFilters)
      } else {
        console.log('Filter error: filter duplicate')
      }
    },
  },
  watch: {
    '$route': 'onRouteChange',
    queryFilter: function (val) {
      const $this = this
      if (!_.isEqual(val, this.newFilters)) {
        let title = this.title + ' for: '
        _.forEach(val, function (field) {
          title += $this.getUnnamedFilter(field)
        })
        this.$emit('changeTitle', title)
        this.$emit('onChanged', val)
      }
    }
  },
  created: function () {
    this.filterQuery();
    this.$emit('onInit', this.filters);
    this.debounced = debounce(this, this.filterSend, 200);
  },
  computed: {
    filterComputed: function () {
      return this.filter
    },
  },
}
</script>

<style scoped>

</style>